import { fetchSingleProductBegin, fetchSingleProductFailure, fetchSingleProductSuccess } from './types';
import { fetchProductBySlug } from '../api/Products';

export const getProduct = (slug) => (dispatch) => {
  dispatch(fetchSingleProductBegin());
  return fetchProductBySlug(slug)
    .then((data) => dispatch(fetchSingleProductSuccess(data)))
    .catch((error) => dispatch(fetchSingleProductFailure(error)));
};
